import { CustomerAccount } from '~/types';
import { CartDetails } from '../cart/index';
import { Drawer } from './Drawer.client';

export function CartDrawer({
  isOpen,
  onClose,
  currency,
  customerAccounts
}: {
  isOpen: boolean;
  onClose: () => void;
  currency: string;
  customerAccounts?: CustomerAccount[];
}) {
  return (
    <Drawer open={isOpen} onClose={onClose} heading="Cart" openFrom="right" backgroundColor='#FAFAFA'>
      <div className="grid">
        <CartDetails currency={currency} layout="drawer" onClose={onClose} customerAccounts={customerAccounts} />
      </div>
    </Drawer>
  );
}